<template>
  <div class="container">
    <div class="nav">
      <div
        class="navItem"
        :class="tabState === 1 ? 'action' : null"
        @click="handlerTab(1)"
      >
        指导员数据管理
      </div>
      <div
        class="navItem"
        :class="tabState === 2 ? 'action' : null"
        @click="handlerTab(2)"
      >
        指导员管理
      </div>
    </div>
    <div class="form">
      <div class="name">姓名</div>
      <el-input v-model="params.name" placeholder="请输入内容"></el-input>
      <el-button type="primary" @click="getGuidanceList">查询</el-button>
      <el-button type="primary" @click="handlerReset">重置</el-button>
    </div>
    <div v-show="tabState === 2" style="margin-top: 30px; margin-bottom: 10px">
      <el-button type="primary" @click="addGuidance">新增指导员</el-button>
    </div>
    <div class="list" style="margin-top: 30px" v-show="tabState === 1">
      <el-table
        stripe
        :data="originData"
        style="width: 100%"
        border
        v-loading="tabLoading"
      >
        <el-table-column prop="name" label="姓名"> </el-table-column>
        <el-table-column prop="phone" label="电话"> </el-table-column>
        <el-table-column prop="name" label="负责社区"> </el-table-column>
        <el-table-column prop="address" label="投放地址"> </el-table-column>
        <el-table-column prop="kitchenCount" label="指导次数">
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination" v-show="tabState === 1">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="this.params.pageNo"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-drawer
      title="新增指导员"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="drawerClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="绑定用户" prop="wlUserId">
          <el-select
            v-model="ruleForm.wlUserId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="loading"
            @change="wlUserIdchange"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.nickname"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="ruleForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="街道" prop="street">
          <el-select
            @change="handlerStreet"
            v-model="ruleForm.street"
            placeholder="请选择街道"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, key) in streetList"
              :key="key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="社区" prop="communityIds">
          <el-select
            placeholder="请选择社区"
            :disabled="communityList.length === 0"
            v-model="ruleForm.communityIds"
          >
            <el-option
              v-for="item in communityList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否通过" prop="status">
          <el-select v-model="ruleForm.status" placeholder="请选择是否通过">
            <el-option label="通过" value="0"></el-option>
            <el-option label="不通过" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="roles">
          <el-checkbox @change="handlerCheckbox">指导员</el-checkbox>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import {
  getGuidanceList,
  frontUserlist,
  addressstreetlist,
  addresscommunitylist,
  frontUserrolelist,
  frontUsercheckUserBind,
  getSaveGuidance,
} from "@/api/management";
export default {
  name: "nguidanceList",
  data() {
    return {
      tabState: 1,
      params: {
        pageNo: 1,
        pageSize: 10,
        name: null,
      },
      total: null,
      loading: false,
      tabLoading: false,
      ruleForm: {
        wlUserId: "",
        name: "",
        phone: "",
        street: "",
        communityIds: "",
        status: "",
        roles: [],
        id: "",
      },
      rules: {
        wlUserId: [
          { required: true, message: "请绑定用户", trigger: "change" },
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 11, max: 11, message: "手机号不正确", trigger: "blur" },
        ],
        street: [
          {
            required: true,
            message: "请选择街道",
            trigger: "blur",
          },
        ],
        communityIds: [
          {
            required: true,
            message: "请选择社区",
            trigger: "blur",
          },
        ],
        address: [
          { required: true, message: "请输入联系地址", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择是否通过", trigger: "blur" },
        ],
        roles: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个角色",
            trigger: "change",
          },
        ],
        avatar: [{ required: true, message: "请上传头像", trigger: "blur" }],
      },
      options: [],
      communityList: [],
      streetList: [],
      originData: [],
      drawer: false,
    };
  },
  methods: {
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.getGuidanceList();
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getGuidanceList();
    },
    handlerReset() {
      this.params.name = null;
      this.getGuidanceList();
    },
    wlUserIdchange(val) {
      frontUsercheckUserBind({
        busiUserId: this.ruleForm.id || "",
        cate: "3",
        wlUserId: val,
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            console.log("验证通过");
          } else {
            console.log("验证未通过");
            this.$message.error("此用户不可被绑定");
            this.ruleForm.wlUserId = "";
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    remoteMethod(query) {
      this.loading = true;
      if (query) {
        frontUserlist({ name: query }).then((res) => {
          if (res.code == 200) {
            this.loading = false;
            this.options = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.options = [];
      }
    },
    handlerCheckbox(val) {
      if (val) {
        this.ruleForm.roles.push(3);
      } else {
        this.ruleForm.roles = [];
      }
    },
    async submitForm() {
      const result = await getSaveGuidance({
        ...this.ruleForm,
        communityIds: [this.ruleForm.communityIds],
      });
      if (result.code === 200) {
        this.$message.success("添加指导员成功");
        this.drawer = false;
      } else {
        this.$message.error(result.msg);
      }
    },
    resetForm() {
      this.ruleForm = {
        name: "",
        phone: "",
        street: "",
        communityIds: "",
        status: "",
        roles: [],
        id: "",
      };
      this.communityList = [];
      this.streetList = [];
    },
    async handlerStreet(val) {
      this.ruleForm.street = val;
      const result = await addresscommunitylist({
        name: "",
        wlStreetId: [val],
      });
      if (result.code === 200) {
        this.communityList = result.data;
      } else {
        this.$message.error(result.msg);
      }
    },

    drawerClose() {
      this.$confirm("确定要关闭吗？")
        .then(() => {
          this.drawer = false;
        })
        .catch(() => {});
    },
    addGuidance() {
      this.drawer = true;
      addressstreetlist({}).then((res) => {
        if (res.code == 200) {
          this.streetList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handlerTab(t) {
      this.tabState = t;
      this.params = {
        pageNo: 1,
        pageSize: 10,
        name: null,
      };
    },
    async getGuidanceList() {
      this.tabLoading = true;
      const result = await getGuidanceList(this.params);
      if (result.code === 200) {
        this.originData = result.data.records;
        this.total = result.data.total;
      } else {
      }
      this.tabLoading = false;
    },
  },
  mounted() {
    this.getGuidanceList();
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 18px;
  .nav {
    display: flex;
    width: 100%;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #ccc;
    .navItem {
      margin-right: 30px;
      padding: 10px 0;
      cursor: pointer;
      margin-bottom: -1px;
    }
    .action {
      color: #409eff;
      border-bottom: 2px solid #409eff;
    }
    .navItem:hover {
      color: #409eff;
    }
  }
  .form {
    display: flex;
    margin-left: 30px;
    margin-top: 20px;
    align-items: center;
    .name {
      white-space: nowrap;
      margin-right: 20px;
    }
    /deep/.el-input--medium {
      width: 15% !important;
      margin-right: 15px;
    }
  }
  .pagination {
    float: right;
    margin-top: 20px;
  }
}
</style>
